module.exports = __webpack_public_path__ + "static/img/plastic-bag.06e8b43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/plastic-bag.png
// module id = tL56
// module chunks = 2